// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button_button__w\\+JtY {
  width: -moz-fit-content;
  width: fit-content;
  display: flex;
  border: none;
  border-radius: 80px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  padding: 11px 24px;
}
.Button_button__w\\+JtY p {
  margin: 0;
}

.Button_default__wAcOz {
  background-color: transparent;
  color: #666666;
  font-size: 12px;
  padding: 0;
}
.Button_default__wAcOz p {
  color: #ffffff;
}

.Button_black__q6rV5 {
  background-color: transparent;
  color: #666666;
  font-size: 12px;
  padding: 0;
}
.Button_black__q6rV5 p {
  color: #1f1f1f;
}

.Button_black-filled__0qeul {
  background-color: #252525;
  color: #fff;
}

.Button_grey__mLxcG {
  color: #666666;
  background-color: transparent;
  font-size: 16px;
  border: solid 1px #666666;
}

.Button_blurred__xl2sS {
  color: #e9e9e9;
  border: solid 1px #e9e9e9;
  background-color: transparent;
}

.Button_primary__ki19P {
  color: #ff6b00;
  background-color: transparent;
  font-size: 14px;
  border: solid 1px #ff6b00;
}

.Button_primary-filled__X0GwZ {
  background-color: #ff6b00;
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
  border: solid 1px #ff6b00;
}

.Button_primary-filled__X0GwZ:hover:not(.Button_no-border__xLDcq),
.Button_primary__ki19P:hover:not(.Button_no-border__xLDcq) {
  background-color: #c75004;
  border: solid 1px #c75004;
  color: #ffffff;
}

.Button_secondary__TOSct {
  color: #1f1f1f;
  background-color: transparent;
  font-size: 16px;
  border: solid 1px #1f1f1f;
}

.Button_secondary-filled__l-OKy {
  color: #ffffff;
  background-color: #1f1f1f;
  border: solid 1px #1f1f1f;
  font-size: 16px;
}

.Button_disable__jLJrW {
  background-color: #e9e9e9;
  cursor: default;
  color: #bbbbbb;
  font-size: 16px;
}

.Button_cursorDefault__c8y5P {
  cursor: default;
}

.Button_cursorDefault__c8y5P {
  cursor: default;
}

.Button_hover__bnrxu {
  transition: background-color 0.4s, border 0.4s;
}

.Button_no-border__xLDcq {
  border: none;
}

.Button_square__MxxhK {
  border-radius: 4px;
}

.Button_spinner__SvEx8 {
  display: inline-block;
  position: relative;
  width: 18px;
  height: 18px;
}

.Button_spinner__SvEx8 div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 14px;
  height: 14px;
  margin: 2px;
  border: 2px solid #fff;
  border-radius: 50%;
  animation: Button_spinner__SvEx8 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}

.Button_spinner__SvEx8 div:nth-child(1) {
  animation-delay: -0.45s;
}

.Button_spinner__SvEx8 div:nth-child(2) {
  animation-delay: -0.3s;
}

.Button_spinner__SvEx8 div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes Button_spinner__SvEx8 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/common/Button/Button.module.scss","webpack://./src/styles/_colors.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AAGA;EACE,uBAAA;EAAA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAFF;AAIE;EACE,SAAA;AAFJ;;AAMA;EACE,6BAAA;EACA,cCbQ;EDcR,eErBO;EFsBP,UAAA;AAHF;AAKE;EACE,cChBI;ADaR;;AAOA;EACE,6BAAA;EACA,cCxBQ;EDyBR,eEhCO;EFiCP,UAAA;AAJF;AAME;EACE,cC/BQ;AD2BZ;;AAQA;EACE,yBCxCY;EDyCZ,WAAA;AALF;;AAQA;EACE,cCvCQ;EDwCR,6BAAA;EACA,eE9CO;EF+CP,yBAAA;AALF;;AAQA;EACE,cCtCsB;EDuCtB,yBAAA;EACA,6BAAA;AALF;;AAQA;EACE,cCxDQ;EDyDR,6BAAA;EACA,eE5DO;EF6DP,yBAAA;AALF;;AAQA;EACE,yBC/DQ;EDgER,cC1DM;ED2DN,eEnEO;EFoEP,iBE9DK;EF+DL,yBAAA;AALF;;AAUE;;EACE,yBCxEY;EDyEZ,yBAAA;EACA,cCrEI;AD+DR;;AAUA;EACE,cC9EU;ED+EV,6BAAA;EACA,eEnFO;EFoFP,yBAAA;AAPF;;AAUA;EACE,cCjFM;EDkFN,yBCtFU;EDuFV,yBAAA;EACA,eE3FO;AFoFT;;AAUA;EACE,yBClFsB;EDmFtB,eAAA;EACA,cCtEY;EDuEZ,eElGO;AF2FT;;AAUA;EACE,eAAA;AAPF;;AAUA;EACE,eAAA;AAPF;;AAUA;EACE,8CAAA;AAPF;;AAUA;EACE,YAAA;AAPF;;AAUA;EACE,kBAAA;AAPF;;AAUA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAPF;;AAUA;EACE,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,2EAAA;EACA,sDAAA;AAPF;;AAUA;EACE,uBAAA;AAPF;;AAUA;EACE,sBAAA;AAPF;;AAUA;EACE,uBAAA;AAPF;;AAUA;EACE;IACE,uBAAA;EAPF;EAUA;IACE,yBAAA;EARF;AACF","sourcesContent":["@use \"styles/colors\";\n@use \"styles/typography\";\n\n.button {\n  width: fit-content;\n  display: flex;\n  border: none;\n  border-radius: 80px;\n  cursor: pointer;\n  align-items: center;\n  justify-content: center;\n  padding: 11px 24px;\n\n  p {\n    margin: 0;\n  }\n}\n\n.default {\n  background-color: transparent;\n  color: colors.$default;\n  font-size: typography.$body-s;\n  padding: 0;\n\n  p {\n    color: colors.$white;\n  }\n}\n\n.black {\n  background-color: transparent;\n  color: colors.$default;\n  font-size: typography.$body-s;\n  padding: 0;\n\n  p {\n    color: colors.$secondary;\n  }\n}\n\n.black-filled {\n  background-color: colors.$neutral-700;\n  color: #fff;\n}\n\n.grey {\n  color: colors.$default;\n  background-color: transparent;\n  font-size: typography.$body-l;\n  border: solid 1px colors.$default;\n}\n\n.blurred {\n  color: colors.$color-button-disabled;\n  border: solid 1px colors.$color-button-disabled;\n  background-color: transparent;\n}\n\n.primary {\n  color: colors.$primary;\n  background-color: transparent;\n  font-size: typography.$body-m;\n  border: solid 1px colors.$primary;\n}\n\n.primary-filled {\n  background-color: colors.$primary;\n  color: colors.$white;\n  font-size: typography.$body-m;\n  font-weight: typography.$bold;\n  border: solid 1px colors.$primary;\n}\n\n.primary-filled:hover,\n.primary:hover {\n  &:not(.no-border) {\n    background-color: colors.$primary-hover;\n    border: solid 1px colors.$primary-hover;\n    color: colors.$white;\n  }\n}\n\n.secondary {\n  color: colors.$secondary;\n  background-color: transparent;\n  font-size: typography.$body-l;\n  border: solid 1px colors.$secondary;\n}\n\n.secondary-filled {\n  color: colors.$white;\n  background-color: colors.$secondary;\n  border: solid 1px colors.$secondary;\n  font-size: typography.$body-l;\n}\n\n.disable {\n  background-color: colors.$color-button-disabled;\n  cursor: default;\n  color: colors.$neutral-400;\n  font-size: typography.$body-l;\n}\n\n.cursorDefault {\n  cursor: default;\n}\n\n.cursorDefault {\n  cursor: default;\n}\n\n.hover {\n  transition: background-color 0.4s, border 0.4s;\n}\n\n.no-border {\n  border: none;\n}\n\n.square {\n  border-radius: 4px;\n}\n\n.spinner {\n  display: inline-block;\n  position: relative;\n  width: 18px;\n  height: 18px;\n}\n\n.spinner div {\n  box-sizing: border-box;\n  display: block;\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  margin: 2px;\n  border: 2px solid #fff;\n  border-radius: 50%;\n  animation: spinner 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n  border-color: #fff transparent transparent transparent;\n}\n\n.spinner div:nth-child(1) {\n  animation-delay: -0.45s;\n}\n\n.spinner div:nth-child(2) {\n  animation-delay: -0.3s;\n}\n\n.spinner div:nth-child(3) {\n  animation-delay: -0.15s;\n}\n\n@keyframes spinner {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n","$neutral: #333333;\n$neutral-700: #252525;\n$accent: #054ab0;\n$primary: #ff6b00;\n$primary-hover: #c75004;\n$secondary: #1f1f1f;\n$secondary-hover: #393939;\n$default: #666666;\n$light: #616c7a;\n$white: #ffffff;\n$light-blue: #ebf3ff;\n$color-background-02: #f2f2f2;\n$color-background-text: #fbfbfb;\n$color-text-02: #333333;\n$color-text-disabled: #808080;\n$color-button-disabled: #e9e9e9;\n$color-semantic-primary: #e6e6e6;\n$color-success-active: #008863;\n$color-success-disable: #32d2a7;\n$color-error-active: #a63631;\n$color-error-disable: #ff9590;\n$error: #c9423c;\n$text-link: #0058e1;\n$text-link-hover: #003b9c;\n$neutral-200: #696969;\n$error-200: #d73a3d;\n$warning-200: #ffb93c;\n$info-200: #1175c9;\n$success-300: #4ba564;\n$neutral-400: #bbbbbb;\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `Button_button__w+JtY`,
	"default": `Button_default__wAcOz`,
	"black": `Button_black__q6rV5`,
	"black-filled": `Button_black-filled__0qeul`,
	"grey": `Button_grey__mLxcG`,
	"blurred": `Button_blurred__xl2sS`,
	"primary": `Button_primary__ki19P`,
	"primary-filled": `Button_primary-filled__X0GwZ`,
	"no-border": `Button_no-border__xLDcq`,
	"secondary": `Button_secondary__TOSct`,
	"secondary-filled": `Button_secondary-filled__l-OKy`,
	"disable": `Button_disable__jLJrW`,
	"cursorDefault": `Button_cursorDefault__c8y5P`,
	"hover": `Button_hover__bnrxu`,
	"square": `Button_square__MxxhK`,
	"spinner": `Button_spinner__SvEx8`
};
export default ___CSS_LOADER_EXPORT___;
